import React, { useMemo } from "react";
import { fmtNum } from "@/lib/format";

export function PicksPanel({ players }) {
  const picks = useMemo(() => players.filter(p => p.position === "PICK"), [players]);

  // Group by year (extracted from name like "2026 Pick 1.01" or "2026 1st")
  const grouped = useMemo(() => {
    const map = {};
    for (const p of picks) {
      const m = p.name.match(/^(\d{4})/);
      const year = m ? m[1] : "Other";
      (map[year] ||= []).push(p);
    }
    for (const year of Object.keys(map)) {
      map[year].sort((a, b) => b.combinedValue - a.combinedValue);
    }
    return map;
  }, [picks]);

  const years = Object.keys(grouped).sort();

  return (
    <section className="mt-16" data-testid="picks-section">
      <div className="flex items-end justify-between mb-4">
        <div>
          <span className="label-eyebrow">06 / Rookie Picks</span>
          <h2 className="font-display font-black text-3xl sm:text-4xl tracking-tighter mt-1">Pick values.</h2>
          <p className="text-sm text-[#52525B] mt-2">2026 & beyond rookie picks, ranked by TRYSTOMATIC value.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {years.map((year) => (
          <div key={year} className="brutal-card" data-testid={`picks-year-${year}`}>
            <div className="border-b border-[#0A0A0A] px-4 py-3 flex items-center justify-between">
              <span className="label-eyebrow">{year} Class</span>
              <span className="font-mono-data text-xs text-[#52525B]">{grouped[year].length} picks</span>
            </div>
            <div className="max-h-[420px] overflow-auto">
              <table className="w-full text-sm">
                <tbody>
                  {grouped[year].map((p, idx) => (
                    <tr key={p.id} className={`border-b border-[#E4E4E7] ${idx % 2 === 0 ? "bg-white" : "bg-[#FAFAFA]"}`}>
                      <td className="px-4 py-2 font-medium">{p.name.replace(/^\d{4}\s*/, "")}</td>
                      <td className="px-4 py-2 text-right font-mono-data tabular-nums text-[#52525B]">#{p.combinedRank}</td>
                      <td className="px-4 py-2 text-right font-mono-data tabular-nums font-semibold">{fmtNum(p.combinedValue)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
        {years.length === 0 && (
          <div className="text-sm text-[#52525B]">No picks data loaded yet.</div>
        )}
      </div>
    </section>
  );
}
